import { useEffect } from 'react';
import queryString from 'query-string';
import { BETA_FEATURE_LLM_EVAL } from '@/lib/betaFeatures';
import { useUpdateUserSettingsMutation } from '@shared/api';
import { APPLICATION_TYPE } from '@shared/constants';
import { useBetaFeatureEnabled } from '@shared/hooks';
import { useCurrentUserContext } from '@shared/hooks/useCurrentUserContext';

function isValidApplicationType(value: unknown): value is APPLICATION_TYPE {
  return Object.values(APPLICATION_TYPE).includes(value as APPLICATION_TYPE);
}

export const useSelectUserApp = () => {
  const { user: currentUser } = useCurrentUserContext();
  const username = currentUser?.username;
  const { changeApplication } = queryString.parse(window.location.search);
  const updateUserSettingsMutation = useUpdateUserSettingsMutation();
  const isLLMEvalEnabled = useBetaFeatureEnabled(BETA_FEATURE_LLM_EVAL);

  useEffect(() => {
    if (!username || typeof changeApplication !== 'string') return;

    const userAppType = changeApplication.toUpperCase();

    if (isLLMEvalEnabled && isValidApplicationType(userAppType)) {
      updateUserSettingsMutation.mutate({
        updates: { userAppType }
      });
    }
  }, [changeApplication, isLLMEvalEnabled, username]);
};
